var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
import QueryString from 'qs';
import { ErrorType, makeRequestError, makeRequestErrorFromResponse } from "./errors";
var API = /** @class */ (function () {
    function API() {
    }
    // noinspection JSUnusedGlobalSymbols
    API.registerGlobalErrorHandler = function (handler) {
        API._errorHandlers = __spreadArray(__spreadArray([], API._errorHandlers, true), [handler], false);
        return function () {
            API._errorHandlers = API._errorHandlers.filter(function (h) { return h !== handler; });
        };
    };
    API._handleGlobalError = function (e) {
        API._errorHandlers
            .forEach(function (handler) { return handler(e); });
    };
    API.initErrorHandling = function () {
        if (API._axios === undefined) {
            return;
        }
        API._axios.interceptors.response.use(function (response) { return response; }, function (error) {
            var errorObj = makeRequestError(ErrorType.Request);
            if (error.response) {
                var response = error.response;
                switch (error.response.status) {
                    case 401:
                        errorObj = makeRequestErrorFromResponse(ErrorType.NotAuthorized, response);
                        break;
                    case 403:
                        errorObj = makeRequestErrorFromResponse(ErrorType.AccessDenied, response);
                        break;
                    case 404:
                        errorObj = makeRequestErrorFromResponse(ErrorType.NotFound, response);
                        break;
                    case 422:
                        errorObj = makeRequestErrorFromResponse(ErrorType.Validation, response);
                        break;
                    case 503:
                        errorObj = makeRequestErrorFromResponse(ErrorType.Maintenance, response);
                        break;
                    default:
                        if (error.response.status >= 500) {
                            errorObj = makeRequestErrorFromResponse(ErrorType.Server, response);
                        }
                        else {
                            errorObj = makeRequestErrorFromResponse(ErrorType.Request, response);
                        }
                        break;
                }
            }
            else if (error.request) {
                if (error.message === 'Network Error' || !navigator.onLine) {
                    errorObj = makeRequestError(ErrorType.Offline);
                }
                else {
                    errorObj = makeRequestError(ErrorType.Request);
                }
            }
            API._handleGlobalError(errorObj);
            throw errorObj;
        });
    };
    API.getAxios = function () {
        if (API._axios === undefined) {
            // noinspection JSAnnotator
            API._axios = axios.create({
                baseURL: API._config.baseUrl,
                timeout: API._config.timeout,
                headers: {
                    post: {
                        'Content-Type': 'application/json',
                    },
                }
            });
            API.initErrorHandling();
        }
        return API._axios;
    };
    // noinspection JSUnusedGlobalSymbols
    API.setConfig = function (config) {
        API._config = __assign(__assign({}, API._config), config);
        API._axios = undefined;
    };
    API._makeUrl = function (url, params) {
        if (params === void 0) { params = null; }
        return url + (params ? '?' + QueryString.stringify(params) : '');
    };
    API._makeOptions = function (options) {
        var _a;
        return {
            timeout: (_a = options === null || options === void 0 ? void 0 : options.timeout) !== null && _a !== void 0 ? _a : API._config.timeout,
        };
    };
    API.get = function (url, params, options) {
        if (params === void 0) { params = null; }
        return API.getAxios().get(API._makeUrl(url, params), this._makeOptions(options));
    };
    API.getData = function (url, params, options) {
        var _this = this;
        if (params === void 0) { params = null; }
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, API.get(url, params, this._makeOptions(options))];
                    case 1:
                        response = _a.sent();
                        resolve(response.data);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        reject(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    API.getFile = function (url, params, options) {
        if (params === void 0) { params = null; }
        return API.getAxios().get(API._makeUrl(url, params), __assign(__assign({}, (options !== null && options !== void 0 ? options : {})), { responseType: 'blob' }));
    };
    API.getMultiple = function (urls, params, options) {
        var _this = this;
        if (params === void 0) { params = null; }
        return axios.all(urls.map(function (url) { return API.getAxios().get(API._makeUrl(url, params), _this._makeOptions(options)); }));
    };
    API.post = function (url, data, options) {
        return API.getAxios().post(url, data, this._makeOptions(options));
    };
    API.create = function (url, data, options) {
        return API.post(url, data, options);
    };
    API.patch = function (url, data, options) {
        return API.getAxios().patch(url, data, this._makeOptions(options));
    };
    API.put = function (url, data, options) {
        return API.getAxios().put(url, data, this._makeOptions(options));
    };
    API.update = function (url, data, options) {
        return API.put(url, data, options);
    };
    API.delete = function (url, data, options) {
        if (data === void 0) { data = null; }
        return API.getAxios().delete(url, __assign({ data: data !== null && data !== void 0 ? data : {} }, this._makeOptions(options)));
    };
    API._makeFormDataValue = function (value) {
        if (value instanceof File) {
            return value;
        }
        if (value instanceof Date) {
            return value.toISOString();
        }
        if (typeof value === 'boolean') {
            return value ? '1' : '0';
        }
        if (typeof value === 'undefined' || value === null) {
            return '';
        }
        return value.toString();
    };
    API._makeFormData = function (data, formData, parentKey) {
        var _this = this;
        if (formData === void 0) { formData = new FormData(); }
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof FileList)) {
            Object.keys(data).forEach(function (key) {
                _this._makeFormData(data[key], formData, parentKey ? "".concat(parentKey, "[").concat(key, "]") : key);
            });
        }
        else if (data instanceof FileList) {
            for (var i = 0; i < data.length; i++) {
                formData.append(parentKey ? "".concat(parentKey, "[]") : '[]', data[i]);
            }
        }
        else {
            formData.append(parentKey || '', this._makeFormDataValue(data));
        }
        return formData;
    };
    API._makeFilesConfig = function (options) {
        return __assign(__assign({}, options), { headers: {
                'Content-Type': 'multipart/form-data'
            } });
    };
    API.postWithFile = function (url, data, options) {
        return API.getAxios().post(url, API._makeFormData(data), API._makeFilesConfig(options));
    };
    API.createWithFile = function (url, data, options) {
        return API.postWithFile(url, data, options);
    };
    API.patchWithFile = function (url, data, options) {
        return API.getAxios().patch(url, API._makeFormData(data), API._makeFilesConfig(options));
    };
    API.updateWithFile = function (url, data, options) {
        return API.patchWithFile(url, data, options);
    };
    API._axios = undefined;
    API._config = {
        baseUrl: '/',
        timeout: 5000,
    };
    API._errorHandlers = [];
    return API;
}());
export var ApiGetMethodsList = ['get', 'getData', 'getFile', 'getMultiple'];
export var ApiSendMethodsList = [
    'post',
    'postWithFile',
    'patch',
    'patchWithFile',
    'put',
    'delete',
    'create',
    'createWithFile',
    'update',
    'updateWithFile',
];
export default API;
//# sourceMappingURL=API.js.map